export default __webpack_public_path__ + "static/media/platform-background.9cd5a61f.svg";